export default __webpack_public_path__ + "static/media/rcn-finance.c80f21f5.jpg";